import React, { Component } from 'react';
import { connect } from "react-redux";
import actions from 'store/actions';
import { Tabs, Row, Col, Button } from 'antd';
import { LoadingOverlay, EventList, FullHeightContainerLayout } from "components";
import { showError, showSuccess } from 'common/ToastNotifications';
import { withRouter } from "react-router";
import _ from 'lodash';

const { TabPane } = Tabs;

class UserAudit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectRecordDetail: null
        }
    }

    componentWillMount() {
        this.props.getUserEvents(this.props.user.userId);
        this.setState({
            fetchingEvents: true
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetUserEventsResultUpdate(prevProps);
    }

    onGetUserEventsResultUpdate = (prevProps) => {
        if (this.props.getUserEventsResult && this.props.getUserEventsResult !== prevProps.getUserEventsResult) {
            if (!this.props.getUserEventsResult.success) {
                if (this.props.getUserEventsResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true
                    });
                }
                else {
                    showError("Unable to get user events.");
                }
            }
            this.setState({
                fetchingEvents: false
            });
        }
    }

    render() {
        return (
            <FullHeightContainerLayout
                showHeader={false}
                showFooter={false}
                content={
                    this.state.fetchingEvents
                        ?
                        <LoadingOverlay
                            busy={true}
                            spinner
                            message="Getting user events...">
                        </LoadingOverlay>
                        :
                        <EventList eventList={this.props.userEventsResult.Items}></EventList>
                }>
            </FullHeightContainerLayout>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getUserEventsResult: state.userAudit.getUserEventsResult,
        userEventsResult: state.userAudit.userEventsResult
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getUserEvents: (userId) => dispatch(actions.getUserEventsRequest(userId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserAudit));